export function mapApiError(error) {
    if (error?.response?.data) {
      const { error: err, message, statusCode } = error.response.data;
  
      return {
        error: err || 'Error',
        message: Array.isArray(message) ? message.join(', ') : message,
        statusCode: statusCode || error.response.status
      };
    }
  
    return {
      error: 'Network Error',
      message: 'Unable to connect to server',
      statusCode: 0
    };
  }
  